import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
})
export class ImprintComponent implements OnInit {
  public currentLanguageCode: string;

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLanguageCode = this.translate.getBrowserLang();
  }
}
